import React from 'react';
import { BookOpenIcon, LifeBuoyIcon, PauseIcon, SlidersHorizontalIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
interface HeaderButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  emphasis?: boolean;
  pressed?: boolean;
}
function HeaderButton({
  label,
  icon,
  onClick,
  emphasis = false,
  pressed
}: HeaderButtonProps) {
  return <button type="button" onClick={onClick} aria-pressed={pressed} className={`flex min-h-[44px] min-w-[44px] items-center justify-center gap-2 rounded-full px-2.5 text-sm font-bold transition-colors duration-150 ease-out lg:px-3.5 ${emphasis ? 'border border-teal text-teal hover:bg-teal hover:text-cream' : 'text-forest hover:bg-sand'}`} data-id="element-443" data-mp="1nv6hkeyeoct">
      {icon}
      <span className="sr-only whitespace-nowrap lg:not-sr-only" data-id="element-444" data-mp="1m3f6yn98jugt">{label}</span>
    </button>;
}
export function Header() {
  const {
    state,
    dispatch,
    openDialog
  } = useDemo();
  const paused = state.currentScreen === 'pause';
  return <header className="aero-glass sticky top-0 z-30 border-b border-line" data-id="element-445" data-mp="jyui8bvjpyse">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2 px-3 py-2 sm:px-6" data-id="element-446" data-mp="oxxlbqrytuxq">
        <div className="flex min-w-0 items-center gap-2" data-id="element-447" data-mp="t02aac7gy3e1">
          <svg viewBox="0 0 32 32" className="h-8 w-8 shrink-0" aria-hidden="true" data-id="element-448" data-mp="syhfclh8sifn">
            <circle cx="16" cy="16" r="15" fill="#087084" data-id="element-449" data-mp="xxavymrtspk1" />
            <ellipse cx="16" cy="9" rx="10" ry="5" fill="#FFFFFF" opacity="0.28" data-id="element-450" data-mp="1a5wxot5hrg3" />
            <path d="M16 24 V12" stroke="#B6C879" strokeWidth="2.4" strokeLinecap="round" data-id="element-451" data-mp="5a7y7wuz4iuu" />
            <ellipse cx="11.5" cy="14" rx="5" ry="2.4" fill="#B6C879" transform="rotate(-30 11.5 14)" data-id="element-452" data-mp="a9awmygg7qtu" />
            <ellipse cx="20.5" cy="11" rx="5" ry="2.4" fill="#DDA24A" transform="rotate(30 20.5 11)" data-id="element-453" data-mp="f12qpiytceoq" />
          </svg>
          <span className="font-display text-xl font-extrabold text-forest" data-id="element-454" data-mp="3dpi1v9eihw4q">SevenAfter</span>
          <span className="aero-pill hidden whitespace-nowrap rounded-full border border-line px-2.5 py-0.5 text-xs font-bold text-teal sm:inline" data-id="element-455" data-mp="3ioktns5he5ur">
            Interactive demo
          </span>
        </div>
        <nav aria-label="Demo tools" className="flex items-center gap-1" data-id="element-456" data-mp="kuztxwaexp6o">
          <HeaderButton label="Field Guide" icon={<BookOpenIcon size={20} aria-hidden="true" data-id="element-458" data-mp="ypk9g3fa3ujh" />} onClick={() => openDialog('fieldGuide')} data-id="element-457" data-mp="ynz9tze3xler" />
          <HeaderButton label="Access" icon={<SlidersHorizontalIcon size={20} aria-hidden="true" data-id="element-460" data-mp="6wjrihjl2kuc" />} onClick={() => openDialog('settings')} data-id="element-459" data-mp="6w08sym3zsf9" />
          <HeaderButton label={paused ? 'Paused' : 'Pause'} pressed={paused} icon={<PauseIcon size={20} aria-hidden="true" data-id="element-462" data-mp="axvbo7joudv5" />} onClick={() => dispatch({
          type: 'OPEN_PAUSE'
        })} data-id="element-461" data-mp="fwyermg3ya0h" />
          <HeaderButton label="Get Support" emphasis icon={<LifeBuoyIcon size={20} aria-hidden="true" data-id="element-464" data-mp="1mdjuqnttmsqo" />} onClick={() => openDialog('support')} data-id="element-463" data-mp="1rbbycf3tw3ap" />
        </nav>
      </div>
    </header>;
}